export const TOGGLE_SIDEBAR_VISIBILITY = 'TOGGLE_SIDEBAR_VISIBILITY';
export const SET_STATUS_MODAL_VISIBILITY = 'SET_STATUS_MODAL_VISIBILITY';
export const SET_MESSAGE_MODAL_VISIBILITY = 'SET_MESSAGE_MODAL_VISIBILITY';
export const SET_COLLATERAL_MODAL_VISIBILITY = 'SET_COLLATERAL_MODAL_VISIBILITY';
export const SET_NOTE_MODAL_VISIBILITY = 'SET_NOTE_MODAL_VISIBILITY';
export const SET_TOUR_VISIBILITY = 'SET_TOUR_VISIBILITY';
export const SET_NOTIFICATIONS_VISIBILITY = 'SET_NOTIFICATIONS_VISIBILITY';
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE';
export const SET_BREADCRUMBS_TEXT = 'SET_BREADCRUMBS_TEXT';